import { render, staticRenderFns } from "./CoinNetworkDeactivationModal.vue?vue&type=template&id=ccd8c5ec&scoped=true&"
import script from "./CoinNetworkDeactivationModal.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkDeactivationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkDeactivationModal.vue?vue&type=style&index=0&id=ccd8c5ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd8c5ec",
  null
  
)

export default component.exports